import {trigger} from "../../utils/events/trigger";
import {SIDEBAR} from "../constants";

export const initAShowSidebarButton = () => {
	const elements = Array.from(document.querySelectorAll(`a.show-sidebar-button`));
	
	if ( elements )
	{
		elements.forEach((el) => el.addEventListener(`click`, () => {
			trigger(SIDEBAR.INPUT, `change`, true);
		}));	
	}
};
